var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
        },
        [
          _c("h1", { staticClass: "h2" }, [_vm._v("Cupons/Comercializadores")]),
          _vm._v(" "),
          _c("div", { staticClass: "btn-toolbar mb-2 mb-md-0" }, [
            _c(
              "div",
              { staticClass: "btn-group mr-2" },
              [
                _c(
                  "BaseButtonComponent",
                  {
                    attrs: {
                      to: `/coupon-owners/new/${_vm.state.coupon}`,
                      variant: "primary-action"
                    }
                  },
                  [_vm._v("Novo")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "btn-group my-2" },
              [
                _c(
                  "BaseButtonComponent",
                  { attrs: { to: "/coupons", variant: "primary-action" } },
                  [_vm._v("Voltar para Cupons")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c(
                "table",
                { staticClass: "table b-table table-hover table-bordered" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("td", [_vm._v("Cupom")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Comercializador")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Comissão(%)")]),
                      _vm._v(" "),
                      _c("td")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.state.list, function(item) {
                      return _c("tr", { key: item.id }, [
                        _c("td", [_vm._v(_vm._s(item.nameCoupon))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center",
                              height: "64px"
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(item.nameAccount))]),
                            _vm._v(" "),
                            item.mainTrader == item.accountId
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      border: "2px solid orange",
                                      "background-color": "transparent",
                                      color: "orange",
                                      padding: "0.5rem",
                                      "border-radius": "0.5rem"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Promotor Principal\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.comission))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "b-overlay",
                              {
                                staticClass: "d-inline-block",
                                attrs: {
                                  show: _vm.busy,
                                  rounded: "",
                                  opacity: "0.6",
                                  "spinner-small": "",
                                  "spinner-variant": "primary"
                                }
                              },
                              [
                                _c(
                                  "BaseButtonComponent",
                                  {
                                    ref: "button",
                                    refInFor: true,
                                    attrs: {
                                      disabled:
                                        _vm.busy ||
                                        item.mainTrader == item.accountId,
                                      variant: "secondary-action",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.promoteTraderToMain(
                                          item.nameCoupon,
                                          item.accountId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Promover a principal\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  to: `/coupon-owners/edit/${item.id}`,
                                  size: "sm",
                                  title: "Editar",
                                  variant: "primary-action"
                                }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "pencil-square",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  size: "sm",
                                  title: "Excluir",
                                  variant: "danger"
                                },
                                on: { click: () => _vm.remove(item) }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "trash",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c("b-pagination-nav", {
                staticClass: "mt-3",
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }